import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import "./ctaSection.scss";
import { useNavigate } from "react-router-dom";

const CtaSection = () => {
    const navigate = useNavigate()
  return (
    <div style={{background:"#f3f4fe"}}>
      <Container>
      <Box className="cta-wrapper">
      
      <Box className="cta-content">
        
        {/* Left Text */}
        <Box className="cta-text">
          <Typography className="cta-heading">
            Looking to Transform Your BFSI Business?
          </Typography>

          <Typography className="cta-subtext">
            Partner with Utilitarian Labs to unlock the full potential of Salesforce for
            banking and financial services.
          </Typography>
        </Box>

        {/* Right Button */}
        <Box className="cta-action">
          <Button className="cta-btn"  onClick={()=>navigate("/Contactform")}>
            CONTACT US
          </Button>
        </Box>

      </Box>

    </Box>
    </Container>
    </div>
  );
};

export default CtaSection;